module.exports = __webpack_public_path__ + "static/media/hills.38d7f086.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/hills.png
// module id = 59
// module chunks = 0